import { render, staticRenderFns } from "./LastFiveIPPopup.vue?vue&type=template&id=5c515b2f"
import script from "./LastFiveIPPopup.vue?vue&type=script&lang=js"
export * from "./LastFiveIPPopup.vue?vue&type=script&lang=js"
import style0 from "./LastFiveIPPopup.vue?vue&type=style&index=0&id=5c515b2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports